import {computed} from "vue";
import {cacheKey} from "@/lib/cache";
import useSwr from "@/core/composables/swr/useSwr";
import {sharingApi} from "@/container";
import {SharingStatus} from "@/core/interfaces/Sharing";

/**
 * Composable to fetch consumer sharings.
 */
const useConsumerSharings = (consumerKey: string, status: SharingStatus | undefined = undefined) => {
    const key = computed(() => {
        return cacheKey(
            'sharings/ownerships',
            {
                consumer_key: consumerKey,
                status: status
            }
        );
    });

    return useSwr(
        key,
        () => sharingApi().ownerships({
            consumer_key: consumerKey,
            status: status
        })
    );
};

export default useConsumerSharings;
